// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__16apR","dragIcon":"SortableItem_dragIcon__2lTAL","disabled":"SortableItem_disabled__19aJ2"};